module.exports = "<span class=\"completer-list-item-holder\" [ngClass]=\"{'completer-title': type === 'title', 'completer-description': type === 'description'}\" >\r\n  <span class=\"completer-list-item\" *ngFor=\"let part of parts\" [ngClass]=\"part.isMatch ? matchClass : null\">{{part.text}}</span>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/autocomplete/components/completer-list-item.component.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/autocomplete/components/completer-list-item.component.html
// module chunks = main